import { MiniCalendarType } from '@lmt/shared-types';
import {
  MiniCalendar,
  Props,
} from '@lmt/unicorn-shared/app/components/calendar/mini-calendar/MiniCalendar';
import styles from '@lmt/unicorn-shared/app/components/calendar/mini-calendar/MiniCalendar.module.scss';
import { ThreeMonthMiniCalendar } from '@lmt/unicorn-shared/app/components/calendar/mini-calendar/ThreeMonthMiniCalendar';
import React, { useEffect, useState } from 'react';
import DownArrow from '../../../icons/arrow-down.svg?react';

type InternalProps = Omit<
  Props,
  'currentMonthDate' | 'onMonthChange' | 'hideMonthArrows'
>;

type SwitchingCalendarProps = {
  miniCalendarType: MiniCalendarType;
} & InternalProps;

export const SwitchingCalendar: React.FC<SwitchingCalendarProps> = (props) => {
  const [miniCalendarType, updateMiniCalendarType] =
    useState<MiniCalendarType>();

  useEffect(
    () => updateMiniCalendarType(props.miniCalendarType),
    [props.miniCalendarType],
  );

  const internalProps = props as InternalProps;

  return (
    <div className={styles.blockWrapper} data-test-id="mini-calendar-block">
      {miniCalendarType == MiniCalendarType.ThreeMonth ? (
        <>
          <ThreeMonthMiniCalendar {...internalProps} />
          <div
            data-test-id={'collapse-button'}
            className={styles.expandButton}
            onClick={() => {
              updateMiniCalendarType(MiniCalendarType.OneMonth);
            }}
          >
            <DownArrow className={styles.upArrow} />
          </div>
        </>
      ) : (
        <>
          <MiniCalendar {...internalProps} />
          <div
            className={styles.expandButton}
            data-test-id={'expand-button'}
            onClick={() => {
              updateMiniCalendarType(MiniCalendarType.ThreeMonth);
            }}
          >
            <DownArrow className={styles.downArrow} />
          </div>
        </>
      )}
    </div>
  );
};
